export default __webpack_public_path__ + "static/media/right-offer_banner.b6673281.jpg";